import { INTERNAL_TAGS_PREFIX, TAGS_PREFIX } from 'app/models/tags/constants';

export const ADD_TAG_SUFFIX = 'tags/add';
export const FETCHED_TAGS_SUFFIX = 'tags/fetched_tags';

const makeActions = (prefix) => ({
  addTag: tag => ({ type: `${prefix}_${ADD_TAG_SUFFIX}`, payload: tag }),
  fetchedTags: response => ({ type: `${prefix}_${FETCHED_TAGS_SUFFIX}`, payload: response }),
});

export const { addTag, fetchedTags } = makeActions(TAGS_PREFIX);

export const {
  addTag: addInternalTag,
  fetchedTags: fetchedInternalTags,
} = makeActions(INTERNAL_TAGS_PREFIX);
